import { ActionType } from "../util/types";
import { Currency } from "./constants";

export const CHANGE_DARK_MODE = "CHANGE_DARK_MODE";
export const SET_ZOOM = "SET_ZOOM";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_CONVERSION_RATE = "SET_CONVERSION_RATE";

export const changeDarkMode = (darkMode: boolean) => ({
  type: CHANGE_DARK_MODE,
  darkMode
} as const);

export const setZoom = (zoom: number) => ({
  type: SET_ZOOM,
  zoom
} as const);

export const setCurrency = (currency: Currency) => ({
  type: SET_CURRENCY,
  currency
} as const);

export const setConversionRate = (conversionRate: number) => ({
  type: SET_CONVERSION_RATE,
  conversionRate
} as const);

export type CommonActions =
  | ActionType<typeof changeDarkMode>
  | ActionType<typeof setZoom>
  | ActionType<typeof setCurrency>
  | ActionType<typeof setConversionRate>